export const LanguageCode = {
    AR: 'ar-EG',
    EN: 'en-US',
};